<template>
    <div id="top_menu-collapse" class="header-inner__col header-inner__col--right">
        <ul class="header-inner__nav-list" v-if="!tablet && !mobile">
            <li v-if="!isGuest" class="header-inner__nav-item header-inner__nav-item--notifications" :class="{'view-informer': userNotificationCount > 0}">
                <span class="header-inner__nav-container" :class="{active: isNotificationActive}" @click="$emit('toggle-notification')">
                    <span class="header-inner__nav-images">
                        <img 
                            class="default" 
                            src="/img/header/notifications.svg" 
                            alt="notifications"
                        />
                        <img 
                            class="active" 
                            src="/img/header/notifications-filled.svg" 
                            alt="notifications"
                        />
                    </span>
                    <span class="js-notification-indecator">
                        <span class="header-inner__count-informer count-informer js-count-informer">{{ userNotificationCount }}</span>
                    </span>
                </span>
            </li>
            <li v-if="!isGuest" class="header-inner__nav-item chat-icon header-inner__nav-item--chat js-chat-icon" :class="{'view-informer': countChat > 0}">
                <a href="/chat/index" class="header-inner__nav-container" :class="{active: isMiniChatOpen}" @click.prevent="toggleMiniChat">
                    <div class="header-inner__user-control-icon messages">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.66667 16.6L5.93667 15.5841L5.945 15.5775C6.21 15.365 6.34417 15.2583 6.49333 15.1825C6.62667 15.1141 6.76917 15.0641 6.91667 15.0341C7.0825 15 7.255 15 7.60167 15H14.8358C15.7675 15 16.2342 15 16.59 14.8183C16.9036 14.6585 17.1585 14.4036 17.3183 14.09C17.5 13.7333 17.5 13.2666 17.5 12.3366V5.99748C17.5 5.06581 17.5 4.59915 17.3183 4.24331C17.1583 3.92963 16.903 3.67467 16.5892 3.51498C16.2333 3.33331 15.7667 3.33331 14.8333 3.33331H5.16667C4.23333 3.33331 3.76667 3.33331 3.41 3.51498C3.09638 3.67472 2.84141 3.92969 2.68167 4.24331C2.5 4.59998 2.5 5.06665 2.5 5.99998V15.5591C2.5 16.4475 2.5 16.8916 2.68167 17.1191C2.75978 17.2172 2.85903 17.2964 2.97201 17.3508C3.08498 17.4052 3.20878 17.4334 3.33417 17.4333C3.62583 17.4333 3.9725 17.155 4.66667 16.6Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <span class="js-chat-indecator">
                        <span class="header-inner__count-informer count-informer">{{ countChat }}</span>
                    </span>
                </a>
            </li>
            <li class="header-inner__nav-item header-inner__nav-item--card card-item" :class="cartCount !== 0 ? 'view-informer' : 'null'">
                <span class="header-inner__nav-container cart-button" :class="{active: isMiniCartActive, 'view-informer': cartCount !== 0}" @click="$emit('toggle-mini-cart')">
                    <span class="header-inner__nav-images">
                        <img 
                            width="24"
                            height="24"
                            class="default" 
                            src="/img/header/cart.svg" 
                            alt="cart"
                        />
                        <img 
                            width="24"
                            height="24"
                            class="active" 
                            src="/img/header/cart-filled.svg" 
                            alt="cart"
                        />
                    </span>
                    <span class="js-card-count-container" :class="{active: cartCount !== 0}">
                        <span class="header-inner__count-informer count-informer count">{{ cartCount }}</span>
                    </span>
                </span>
                <MiniCart
                    v-if="isFetchHeaderReady && cartCount !== 0"
                    :isShowRegionModal="isShowRegionModal"
                    :isMiniCartActive="isMiniCartActive"
                    :isUserSeller="isUserSeller"
                    :isGuest="isGuest"
                    :cartDataProp="cartData"
                    :mobile="mobile"
                    @modal-region-show="$emit('modal-region-show')"
                    @show-auth-modal="showAuthModal"
                    @close-mini-cart="$emit('toggle-mini-cart')"/>
            </li>
        </ul>
        <MiniChatWrap v-if="!isGuest && isFetchHeaderReady"
            :isMiniChatActive="isMiniChatOpen"
            :mobile="mobile"
            @active-chat="$emit('is-active-chat')"
            @close-mini-chat-wrap="$emit('toggle-mini-chat')"
            @enabled-chat="$emit('enabled-chat-icon')"
            @count-chat="handleChatUnreadCount" />
        <ul class="header-inner__nav-list" :class="{guest: isGuest}" v-if="!tablet">
            <li class="header-user-block user-block" v-if="isGuest">
                <a class="header-user-block__auth" href="#" @click.prevent="showAuthModal" :aria-label="$t('Sign in')">
                    <span>
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50014 18.875V17.3125C8.50014 16.881 8.84919 16.5312 9.27987 16.5312C9.71055 16.5312 10.0596 16.881 10.0596 17.3125V18.875C10.0596 19.7365 10.7592 20.4375 11.6191 20.4375H19.4553C20.3151 20.4375 21.0148 19.7365 21.0148 18.875V5.125C21.0148 4.26349 20.3151 3.5625 19.4553 3.5625H11.6191C10.7592 3.5625 10.0596 4.26349 10.0596 5.125V6.6875C10.0596 7.11902 9.71055 7.46875 9.27987 7.46875C8.84919 7.46875 8.50014 7.11902 8.50014 6.6875V5.125C8.50014 3.40182 9.89924 2 11.6191 2H19.4553C21.1751 2 22.5742 3.40182 22.5742 5.125V18.875C22.5742 20.5982 21.1751 22 19.4553 22H11.6191C9.89924 22 8.50014 20.5982 8.50014 18.875Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
                        <path d="M12.5027 8.90857L14.2488 10.658C15.0088 11.4196 15.0088 12.6586 14.2488 13.4201L12.5027 15.1696C12.3505 15.3221 12.151 15.3984 11.9513 15.3984C11.7518 15.3984 11.5523 15.3221 11.4 15.1696C11.0954 14.8645 11.0954 14.3698 11.4 14.0648L12.6419 12.8203H3.27973C2.84905 12.8203 2.5 12.4706 2.5 12.0391C2.5 11.6075 2.84905 11.2578 3.27973 11.2578H12.6419L11.4 10.0133C11.0954 9.70828 11.0954 9.21359 11.4 8.90857C11.7044 8.60339 12.1982 8.60339 12.5027 8.90857Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
                        </svg>
                    </span>
                    <span class="hide-mobile">
                        {{ $t("Sign in") }}
                    </span>
                </a>
            </li>
            <div v-else class="header-user-block__controls wrap-dropdown">
                <button class="header-user-block__controls-btn" @click="$emit('toggle-sidebar')" :class="{ active: isSidebarActive }">
                    <div class="header-user-block__avatar">
                        <img :src="avatar.src" :alt="avatar.alt" :title="avatar.title" class="img-circle img-responsive">
                        <span class="header-user-block__burger-item">
                            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.54919 2.06689H3.99919H6.44919M1.54919 4.06689H6.44919M1.54919 6.0669H6.44919" stroke="#9D9D9D" stroke-width="0.758333" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </div>
                </button>
            </div>
        </ul>
        <a v-if="tablet && !isGuest"
            href="/chats"
            class="header-inner__link-tablet"
            :class="{active: enabledChatIcon}"
            :aria-label="$t('Chats')">
            <svg aria-hidden="true" width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.66667 16.6L5.93667 15.5841L5.945 15.5775C6.21 15.365 6.34417 15.2583 6.49333 15.1825C6.62667 15.1141 6.76917 15.0641 6.91667 15.0341C7.0825 15 7.255 15 7.60167 15H14.8358C15.7675 15 16.2342 15 16.59 14.8183C16.9036 14.6585 17.1585 14.4036 17.3183 14.09C17.5 13.7333 17.5 13.2666 17.5 12.3366V5.99748C17.5 5.06581 17.5 4.59915 17.3183 4.24331C17.1583 3.92963 16.903 3.67467 16.5892 3.51498C16.2333 3.33331 15.7667 3.33331 14.8333 3.33331H5.16667C4.23333 3.33331 3.76667 3.33331 3.41 3.51498C3.09638 3.67472 2.84141 3.92969 2.68167 4.24331C2.5 4.59998 2.5 5.06665 2.5 5.99998V15.5591C2.5 16.4475 2.5 16.8916 2.68167 17.1191C2.75978 17.2172 2.85903 17.2964 2.97201 17.3508C3.08498 17.4052 3.20878 17.4334 3.33417 17.4333C3.62583 17.4333 3.9725 17.155 4.66667 16.6Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <span class="header-inner__link-tablet-count" :class="{active: countChat > 0}">{{ countChat }}</span>
        </a>
        <div v-if="tablet && !isGuest" class="header-burger-menu__user-avatar header-burger-menu__user-avatar--nav" @click="$emit('toggle-sidebar')" :class="{ active: isSidebarActive }">
            <img :src="avatar.src" :alt="avatar.alt" :title="avatar.title" class="img-circle img-responsive">
            <span class="header-burger-menu__burger-toggle--default">
                <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_4356_19542)">
                        <path d="M1.25 1.61914H3H4.75M1.25 3.04771H4.75M1.25 4.47628H4.75" stroke="#9D9D9D" stroke-width="0.541667" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_4356_19542">
                        <rect width="5" height="5" fill="white" transform="translate(0.5 0.5)"/>
                    </clipPath>
                    </defs>
                </svg>
            </span>
            <span class="header-burger-menu__burger-toggle--active">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3838 11.7L4.33474 5.65099C3.88842 5.20468 3.88842 4.48106 4.33474 4.03475C4.78105 3.58843 5.50467 3.58843 5.95098 4.03475L12 10.0838L18.049 4.03475C18.4953 3.58843 19.219 3.58843 19.6653 4.03475C20.1116 4.48106 20.1116 5.20468 19.6653 5.65099L13.6162 11.7L19.6653 17.749C20.1116 18.1953 20.1116 18.919 19.6653 19.3653C19.219 19.8116 18.4953 19.8116 18.049 19.3653L12 13.3163L5.95098 19.3653C5.50467 19.8116 4.78105 19.8116 4.33474 19.3653C3.88842 18.919 3.88842 18.1953 4.33474 17.749L10.3838 11.7Z" fill="#4E8AFF"/>
                </svg>
            </span>
        </div>
        <a v-if="tablet && isGuest" class="header-user-block__auth" href="#" @click.prevent="showAuthModal" :aria-label="$t('Sign in')">
            <span>
                <svg width="25" height="24" viewBox="0 0 25 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50014 18.875V17.3125C8.50014 16.881 8.84919 16.5312 9.27987 16.5312C9.71055 16.5312 10.0596 16.881 10.0596 17.3125V18.875C10.0596 19.7365 10.7592 20.4375 11.6191 20.4375H19.4553C20.3151 20.4375 21.0148 19.7365 21.0148 18.875V5.125C21.0148 4.26349 20.3151 3.5625 19.4553 3.5625H11.6191C10.7592 3.5625 10.0596 4.26349 10.0596 5.125V6.6875C10.0596 7.11902 9.71055 7.46875 9.27987 7.46875C8.84919 7.46875 8.50014 7.11902 8.50014 6.6875V5.125C8.50014 3.40182 9.89924 2 11.6191 2H19.4553C21.1751 2 22.5742 3.40182 22.5742 5.125V18.875C22.5742 20.5982 21.1751 22 19.4553 22H11.6191C9.89924 22 8.50014 20.5982 8.50014 18.875Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
                <path d="M12.5027 8.90857L14.2488 10.658C15.0088 11.4196 15.0088 12.6586 14.2488 13.4201L12.5027 15.1696C12.3505 15.3221 12.151 15.3984 11.9513 15.3984C11.7518 15.3984 11.5523 15.3221 11.4 15.1696C11.0954 14.8645 11.0954 14.3698 11.4 14.0648L12.6419 12.8203H3.27973C2.84905 12.8203 2.5 12.4706 2.5 12.0391C2.5 11.6075 2.84905 11.2578 3.27973 11.2578H12.6419L11.4 10.0133C11.0954 9.70828 11.0954 9.21359 11.4 8.90857C11.7044 8.60339 12.1982 8.60339 12.5027 8.90857Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
                </svg>
            </span>
        </a>
        <Notifications 
            v-if="isFetchHeaderReady && !isGuest"
            :mobile="mobile"
            :tablet="tablet"
            :language="language"
            :notificationData="notificationData"
            :isNotificationActive="isNotificationActive"
            @close-notify="$emit('toggle-notification')"
            @count-notification="$emit('count-notification', $event)"/>
    </div>
</template>
  
<script>
  import Notifications from './Notifications.vue';
  import MiniCart from './MiniCart.vue';
  import MiniChatWrap from './MiniChatWrap.vue';

  export default {
    name: 'NavbarRight',
    components: {
        Notifications,
        MiniCart,
        MiniChatWrap,
    },
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
        tablet: {
            type: Boolean,
            default: false,
        },
        language: {
            type: String,
            default: 'en',
        },
        isGuest: {
            type: Boolean,
            default: false,
        },
        isUserSeller: {
            type: Boolean,
            default: false,
        },
        isSidebarActive: {
            type: Boolean,
            default: false,
        },
        isNotificationActive: {
            type: Boolean,
            default: false,
        },
        isMiniCartActive: {
            type: Boolean,
            default: false,
        },
        isFetchHeaderReady: {
            type: Boolean,
            default: false,
        },
        enabledChatIcon: {
            type: Boolean,
            default: false,
        },
        isMiniChatOpen: {
            type: Boolean,
            default: false,
        },
        isEnableMiniChat: {
            type: Boolean,
            default: true,
        },
        isShowRegionModal: {
            type: Boolean,
            default: false,
        },
        cartCount: {
            type: Number,
            default: 0,
        },
        countChat: {
            type: Number,
            default: 0,
        },
        userNotificationCount: {
            type: Number,
            default: 0,
        },
        cartData: {
            type: Object,
            default: () => {},
        },
        notificationData: {
            type: Object,
            default: () => {},
        },
        avatar: {
            type: Object,
            default: () => {},
        },
    },
    methods: {
        handleChatUnreadCount(count) {
            this.$emit('count-chat', count);
        },
        toggleMiniChat() {
            if (this.isEnableMiniChat && !this.tablet && !this.mobile) {
                this.$emit('toggle-mini-chat');
            } else {
                window.location.href = '/chat/index';
            }
        },
        showAuthModal() {
            window.dispatchEvent(new CustomEvent('showAuthModal'));
        },
    },
  };
  </script>